import { Functions } from '@sharedlib/common/lang/Functions';

export namespace SignalUtils {
  export function memoizeDate(factory: Functions.Provider<Date>): Functions.Provider<Date> {
    let last: Date | null = null;
    return (): Date => {
      const next = factory();
      if (last?.getTime() === next.getTime()) {
        return last;
      }
      last = next;
      return next;
    };
  }
}
